<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M371 1226 c-43 -24 -50 -52 -51 -187 0 -119 2 -128 25 -163 34 -51
24 -65 -89 -126 -52 -28 -99 -57 -105 -64 -13 -16 -101 -311 -101 -339 0 -11
19 -44 41 -74 35 -45 46 -53 75 -53 l33 0 3 -88 3 -87 280 0 280 0 3 108 3
107 62 0 62 1 89 102 c69 78 106 111 163 145 l73 42 0 97 0 97 -42 43 -41 42
12 54 c12 47 11 58 -3 85 -22 42 -40 50 -111 48 -72 -2 -83 -8 -102 -53 -12
-30 -12 -43 -2 -84 l13 -49 -37 -38 c-37 -38 -37 -38 -37 -125 l0 -87 51 0
c31 0 48 -4 44 -10 -7 -11 -105 -63 -110 -58 -1 2 -15 37 -31 78 -16 41 -39
87 -52 102 l-23 27 32 41 c26 32 30 43 20 53 -10 10 -21 3 -51 -32 l-39 -45
-48 26 c-26 15 -56 38 -67 51 -18 24 -18 25 5 57 22 28 24 44 27 157 4 140 -5
176 -49 198 -36 19 -175 19 -208 1z m117 -42 c12 -8 22 -21 22 -29 0 -18 -53
-35 -106 -35 -40 0 -44 2 -44 24 0 31 34 56 75 56 17 0 41 -7 53 -16z m99 -19
c2 -8 3 -19 1 -25 -5 -16 -35 10 -43 38 -6 22 -5 23 15 12 11 -6 24 -18 27
-25z m-16 -65 c16 -9 19 -22 19 -91 0 -92 -15 -131 -60 -154 -57 -30 -127 -10
-155 45 -9 18 -15 57 -15 105 l0 75 48 0 c26 1 61 7 77 15 37 17 61 18 86 5z
m456 -131 c8 -8 17 -8 33 1 19 10 26 9 43 -9 19 -19 20 -25 9 -66 -7 -25 -12
-78 -13 -118 l-1 -72 -21 65 c-14 40 -28 65 -36 65 -9 0 -23 -24 -35 -65 l-20
-65 -7 95 c-3 52 -9 103 -13 113 -5 11 -2 26 8 42 18 27 35 32 53 14z m-518
-197 c-16 -18 -30 -33 -32 -35 -2 -1 -17 14 -34 33 l-31 35 63 0 63 0 -29 -33z
m-69 -68 c0 -10 -30 -29 -35 -22 -3 6 -25 86 -25 94 0 12 59 -59 60 -72z m118
26 c-14 -56 -12 -54 -37 -40 -21 11 -21 11 11 50 18 21 34 38 35 36 1 -1 -3
-22 -9 -46z m398 -67 c24 -9 63 14 70 42 6 26 24 35 24 12 0 -21 46 -59 67
-55 14 2 19 14 21 52 3 47 4 48 23 30 14 -13 19 -30 19 -71 l0 -53 -140 0
-140 0 0 52 c0 35 6 58 18 71 16 19 17 18 20 -27 2 -31 8 -49 18 -53z m-618
-64 l-3 -141 -70 -25 c-79 -28 -90 -36 -82 -57 5 -12 27 -7 127 31 67 25 125
41 130 36 7 -8 32 -124 27 -129 -14 -12 -209 -54 -254 -54 -57 0 -61 1 -91 39
-18 22 -32 46 -32 53 1 25 89 313 97 315 4 2 35 19 68 37 33 19 66 35 73 35
10 1 12 -31 10 -140z m312 126 c31 -16 42 -42 14 -31 -10 4 -25 -1 -35 -10
-18 -16 -19 -16 -19 19 0 42 1 42 40 22z m97 -57 c6 -7 27 -57 48 -110 20 -54
41 -98 46 -98 5 0 35 13 67 29 54 27 58 27 83 12 14 -9 27 -20 29 -24 1 -5
-31 -47 -71 -93 l-73 -84 -60 0 c-60 1 -61 1 -94 45 -21 29 -37 42 -47 39 -21
-9 -19 -16 20 -67 34 -45 35 -48 35 -141 l0 -96 -60 0 -60 0 0 138 c0 120 3
141 20 167 14 21 20 47 20 88 0 52 4 63 42 113 31 41 38 58 30 66 -7 7 -12 16
-12 20 0 13 26 9 37 -4z m-233 -23 c18 -14 38 -25 45 -25 39 0 -97 -122 -152
-135 l-27 -7 0 71 c0 50 4 71 13 71 6 0 26 11 42 25 37 30 39 30 79 0z m160
-4 c9 -14 -58 -84 -77 -80 -16 3 -13 10 18 47 37 42 49 49 59 33z m506 -65 c0
-7 -109 -66 -122 -66 -7 0 -24 9 -38 19 -20 16 -22 21 -11 35 10 12 32 16 92
16 44 0 79 -2 79 -4z m-570 -104 c0 -68 -21 -94 -73 -90 -41 3 -42 4 -51 46
-9 41 -7 45 20 67 19 16 42 24 67 25 l37 0 0 -48z m-40 -262 l0 -130 -45 0
c-54 0 -57 13 -20 68 21 31 25 48 25 114 0 71 2 78 20 78 19 0 20 -7 20 -130z
m-80 26 c0 -29 -7 -52 -21 -70 -11 -15 -24 -39 -28 -54 -5 -20 -15 -28 -34
-30 l-27 -3 0 85 0 85 48 14 c26 8 50 15 55 16 4 1 7 -19 7 -43z m-150 -76 l0
-80 -50 0 -50 0 0 68 0 69 48 10 c26 6 48 11 50 12 1 0 2 -35 2 -79z"
      />
      <path
        d="M403 1025 c-7 -20 2 -29 21 -22 9 4 13 13 10 22 -8 19 -23 19 -31 0z"
      />
      <path
        d="M515 1031 c-8 -15 3 -31 21 -31 9 0 14 7 12 17 -4 20 -24 28 -33 14z"
      />
      <path
        d="M473 960 c-3 -11 -12 -20 -19 -20 -8 0 -14 -9 -14 -20 0 -26 31 -27
53 -2 22 24 22 62 1 62 -9 0 -18 -9 -21 -20z"
      />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
